"use strict";

var defaultDoubleThickFee = 10;

module.exports = function (accumulator, order, product, component, options) {
  var addition = 0;
  var doubleThickFee = options.doubleThickFee || defaultDoubleThickFee;

  if (product.paper_type && product.paper_type.match(/double thick/i)) {
    addition = doubleThickFee;
  }

  return (parseFloat(accumulator, 10) || 0) + addition;
};